import { useEffect, useState } from 'react';
import { fetchAndColorizeSvgData } from 'utils/common/common';

type Props = {
  iconUri: string;
  iconColor: string;
};

export default function useColorizeSvg({ iconUri, iconColor }: Props) {
  const [svgDataUri, setSvgDataUri] = useState<string | null>(null);

  useEffect(() => {
    fetchAndColorizeSvgData(iconUri, iconColor).then(setSvgDataUri);
  }, [iconUri, iconColor]);

  return { svgDataUri };
}
